import { useEffect, useState } from "react";
import ahshootLogo from "../../../assets/logo/ahshoot-logo.png";

function isActivePath(pathname, targetPath) {
  if (targetPath === "/team") {
    return pathname === "/team" || pathname.startsWith("/team/");
  }
  return pathname === targetPath || pathname.startsWith(`${targetPath}/`);
}

function FooterNavButton({ label, active, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`h-11 min-w-[76px] rounded-xl px-3 text-sm font-semibold transition ${
        active ? "bg-[#111827] text-white" : "text-[#667085] hover:bg-[#f2f4f7]"
      }`}
    >
      {label}
    </button>
  );
}

function MenuActionButton({ label, onClick, danger = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`h-10 w-full rounded-lg border px-3 text-left text-sm font-semibold transition ${
        danger
          ? "border-[#fecdca] bg-[#fef3f2] text-[#b42318] hover:bg-[#fee4e2]"
          : "border-[#d0d5dd] bg-white text-[#344054] hover:bg-[#f9fafb]"
      }`}
    >
      {label}
    </button>
  );
}

function ClientAppShell({
  isAuthenticated,
  currentUser,
  pathname,
  onLogout,
  children,
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  const handleMove = (path, { authRequired = false } = {}) => {
    if (authRequired && !isAuthenticated) {
      window.location.replace("/auth/login");
      return;
    }
    window.location.replace(path);
  };

  return (
    <div className="min-h-screen bg-[#f8fafc]">
      <header className="fixed inset-x-0 top-0 z-40 border-b border-[#e4e7ec] bg-white/95 px-4 py-3 backdrop-blur-sm md:px-6">
        <div className="mx-auto flex w-full max-w-[1200px] items-center justify-between gap-3">
          <button
            type="button"
            onClick={() => window.location.replace("/")}
            className="flex items-center gap-2 rounded-lg px-1 text-left"
          >
            <img
              src={ahshootLogo}
              alt="Ah Shoot 로고"
              className="h-7 w-7 rounded-lg object-cover"
            />
            <p className="m-0 text-sm font-bold tracking-[0.06em] text-[#111827]">
              AH SHOOT
            </p>
          </button>

          <button
            type="button"
            aria-label="메뉴 열기"
            onClick={() => setIsMenuOpen((previous) => !previous)}
            className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-[#d0d5dd] bg-white text-[#344054] transition hover:bg-[#f9fafb]"
          >
            <span className="text-lg leading-none">☰</span>
          </button>
        </div>

        {isMenuOpen && (
          <>
            <div
              className="fixed inset-0 z-40 bg-[#101828]/20"
              onClick={() => setIsMenuOpen(false)}
              aria-hidden="true"
            />
            <div className="absolute right-4 top-[62px] z-50 w-[220px] rounded-2xl border border-[#e4e7ec] bg-white p-3 shadow-[0_18px_45px_rgba(16,24,40,0.18)] md:right-6">
              <p className="mb-2 px-1 text-xs text-[#667085]">
                {isAuthenticated
                  ? currentUser?.nickname || currentUser?.email || "사용자"
                  : "게스트"}
              </p>
              <div className="space-y-2">
                <MenuActionButton
                  label="팀 찾기"
                  onClick={() => handleMove("/teams/find")}
                />
                <MenuActionButton
                  label="팀 등록"
                  onClick={() =>
                    handleMove("/teams/new", { authRequired: true })
                  }
                />
                {isAuthenticated && (
                  <MenuActionButton
                    label="설정"
                    onClick={() => handleMove("/settings", { authRequired: true })}
                  />
                )}
                {isAuthenticated ? (
                  <MenuActionButton
                    label="로그아웃"
                    onClick={() => {
                      setIsMenuOpen(false);
                      if (onLogout) {
                        onLogout();
                      }
                    }}
                    danger
                  />
                ) : (
                  <MenuActionButton
                    label="로그인"
                    onClick={() => handleMove("/auth/login")}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </header>

      <div className="pb-[60px] pt-[62px]">{children}</div>

      <footer className="fixed inset-x-0 bottom-0 z-40 border-t border-[#e4e7ec] bg-white px-3 py-2 md:px-6">
        <div className="mx-auto flex w-full max-w-[760px] items-center justify-between gap-1">
          <FooterNavButton
            label="홈"
            active={isActivePath(pathname, "/")}
            onClick={() => handleMove("/")}
          />
          <FooterNavButton
            label="팀"
            active={isActivePath(pathname, "/team")}
            onClick={() => handleMove("/team", { authRequired: true })}
          />
          <FooterNavButton
            label="일정"
            active={isActivePath(pathname, "/schedule")}
            onClick={() => handleMove("/schedule", { authRequired: true })}
          />
          <FooterNavButton
            label="MY"
            active={isActivePath(pathname, "/my")}
            onClick={() => handleMove("/my", { authRequired: true })}
          />
        </div>
      </footer>
    </div>
  );
}

export default ClientAppShell;
